export default __webpack_public_path__ + "static/media/arrow-link-down-expand-small_white.336e0fa8.svg";